<template>
	<div class="m_container"  :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="page_bg" style="padding-bottom: 100px;"  :class="openType != 'mob' ? 'container_w_h' : 'vh100'">
			<div class="flex pt20 pb20 bgfff plr20">
				<div class="pr20">
					项目名称
				</div>
				<input class="flex1" type="text" v-model="name" placeholder="请输入项目名称" />
			</div>
			<div class="flex pt20 pb20 bgfff plr20">
				<div class="pr20">
					项目状态
				</div>
				<div>
					<RadioGroup v-model="checked" checked-color="#00D8CC" direction="horizontal">
						<Radio name="1">正常</Radio>
						<Radio name="0">停用</Radio>
					</RadioGroup>
				</div>
			</div>
		</div>
		<div class="bottom_btn" @click="submit">
			<div class="btn_contenbt">提交</div>
		</div>
	</div>
</template>

<script>
	import {openType} from '@/utils/tool.js'
	import { RadioGroup, Radio } from 'vant';
	export default {
		data() {
			return {
				name: '',
				checked:'1',
				flag:true,
				openType:openType()
			}
		},
		components:{
			RadioGroup, Radio
		},
		created() {
			this.openType = openType();
			this.flag = true;
		},
		methods:{
			submit(){
				if(!this.name){
					this.Toast('请输入项目名称')
					return
				}
				if(!this.flag){
					return
				}
				this.flag = false
				this.api.projectNew({name:this.name,status:this.checked}).then((res) => {
					this.Toast('创建成功');
					setTimeout(() => {
						this.$router.push({
							path:'/mListDetail',
							query:{id:res.data.id}
						})
					},1500)
					this.flag = true
				}).catch(() => {
					this.flag = true
				})
			}
		}
	}
</script>

<style>
</style>
